import { EXCEL_MAX_CELL_LENGTH, FORBIDDEN_FILE_NAME_CHARACTERS, TASKS_EXPORT_FILE_NAME_SUFFIX } from './constants';

/**
 * Converts an API timestamp to a date Excel renders as the same calendar day the UI shows.
 */
export const toExcelDate = (value: string | null | undefined): Date | null => {
    if (!value) return null;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return null;
    return new Date(Date.UTC(parsed.getFullYear(), parsed.getMonth(), parsed.getDate()));
};

/** Excel refuses to open a workbook containing an over-long cell, so clip rather than fail the export. */
export const truncateForCell = (value: string): string => (
    value.length > EXCEL_MAX_CELL_LENGTH ? value.slice(0, EXCEL_MAX_CELL_LENGTH) : value
);

const formatExportDate = (date: Date): string => [
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
    String(date.getFullYear()).slice(-2),
].join('.');

/**
 * `[deal name] - tasks - [date exported]`, with characters that are not supported in file names removed.
 */
export const buildTasksExportFileName = (dealName: string | null | undefined, exportedAt: Date = new Date()): string => {
    const name = `${dealName || 'Deal'} - ${TASKS_EXPORT_FILE_NAME_SUFFIX} - ${formatExportDate(exportedAt)}`;
    return name.replace(FORBIDDEN_FILE_NAME_CHARACTERS, '').trim();
};
